const translations = {
  GRID_HEADER_REQUESTING_EMPLOYEE: {
    description: "Requested By",
    primaryValue: "Requesting Employee",
    stringKey: "GRID_HEADER_REQUESTING_EMPLOYEE",
  },
  GRID_HEADER_REQUEST_TYPE: {
    description: "Type of Requested Pass",
    primaryValue: "Request Type",
    stringKey: "GRID_HEADER_REQUEST_TYPE",
  },
  GRID_HEADER_ORGANIZATION: {
    description: "Organization Name",
    primaryValue: "Organization",
    stringKey: "GRID_HEADER_ORGANIZATION",
  },
  GRID_HEADER_DATE_SUBMITTED: {
    description: "Pass Submitted Date",
    primaryValue: "Date Submitted",
    stringKey: "GRID_HEADER_DATE_SUBMITTED",
  },
  GRID_HEADER_NUMBER_OF_VISITORS: {
    description: "Number of Visitors",
    primaryValue: "# Of Visitors",
    stringKey: "GRID_HEADER_NUMBER_OF_VISITORS",
  },
  GRID_HEADER_STATUS: {
    description: "Requested Pass Status",
    primaryValue: "Status",
    stringKey: "GRID_HEADER_STATUS",
  },
  GRID_HEADER_ACTIONS: {
    description: "Grid Actions",
    primaryValue: "Actions",
    stringKey: "GRID_HEADER_ACTIONS",
  },
  APPROVAL_GRID_EMPTY_TEXT: {
    description: "No approval found",
    primaryValue: "You have no pending approvals",
    stringKey: "APPROVAL_GRID_EMPTY_TEXT",
  },
  APPROVAL_STATUS_APPROVED: {
    description: "Pass Status Approved",
    primaryValue: "Approved",
    stringKey: "APPROVAL_STATUS_APPROVED",
  },
  PASS_STATUS_DECLINED: {
    description: "Pass Status Declined",
    primaryValue: "Declined",
    stringKey: "PASS_STATUS_DECLINED",
  },
  PASS_STATUS_PENDING: {
    description: "Pass Status Pending",
    primaryValue: "Pending",
    stringKey: "PASS_STATUS_PENDING",
  },
  PASS_TYPE_AFFILIATE: {
    description: "Affiliate Pass Type",
    primaryValue: "Affiliate",
    stringKey: "PASS_TYPE_AFFILIATE",
  },
  PASS_TYPE_ALL_TYPES: {
    description: "All Pass Types",
    primaryValue: "All Types",
    stringKey: "PASS_TYPE_ALL_TYPES",
  },
  PASS_TYPE_COMP: {
    description: "Comp Pass Type",
    primaryValue: "Comp",
    stringKey: "PASS_TYPE_COMP",
  },
  PASS_TYPE_ELITE: {
    description: "Elite Pass Type",
    primaryValue: "Elite",
    stringKey: "PASS_TYPE_ELITE",
  },
  PASS_TYPE_EMPLOYEE: {
    description: "Employee Pass Type",
    primaryValue: "Employee",
    stringKey: "PASS_TYPE_EMPLOYEE",
  },
  PASS_TYPE_FAMILY: {
    description: "Family Pass Type",
    primaryValue: "Family",
    stringKey: "PASS_TYPE_FAMILY",
  },
  PASS_TYPE_GOLDCARD: {
    description: "GoldCard Pass Type",
    primaryValue: "GoldCard",
    stringKey: "PASS_TYPE_GOLDCARD",
  },
  PASS_TYPE_GUEST: {
    description: "Guest Pass Type",
    primaryValue: "Guest",
    stringKey: "PASS_TYPE_GUEST",
  },
  PASS_TYPE_UNDEFINED: {
    description: "Undefined Pass Type",
    primaryValue: "Undefined",
    stringKey: "PASS_TYPE_UNDEFINED",
  },
  PASS_TYPE_VENDOR: {
    description: "Family Pass Type",
    primaryValue: "Family",
    stringKey: "PASS_TYPE_VENDOR",
  },
  PASS_TYPE_VIP: {
    description: "VIP Pass Type",
    primaryValue: "VIP",
    stringKey: "PASS_TYPE_VIP",
  },
  HEADER_BAR_APPROVALS: {
    description: "Approvals Grid",
    primaryValue: "Approvals",
    stringKey: "HEADER_BAR_APPROVALS",
  },
  APPROVAL_REQUEST_APPROVED: {
    description: "Approval Request Approved",
    primaryValue: "Request Approved",
    stringKey: "APPROVAL_REQUEST_APPROVED",
  },
  APPROVAL_ERROR_APPROVING: {
    description: "Error Approving Request",
    primaryValue: "Error approving passes",
    stringKey: "APPROVAL_ERROR_APPROVING",
  },
  APPROVAL_REQUEST_DECLINED: {
    description: "Approval Request Declined",
    primaryValue: "Request Declined",
    stringKey: "APPROVAL_REQUEST_DECLINED",
  },
  APPROVAL_ERROR_DECLINING: {
    description: "Error Declining Request",
    primaryValue: "Error declining passes",
    stringKey: "APPROVAL_ERROR_DECLINING",
  },
  APPROVAL_SUB_TEXT: {
    description: "Approvals Sub Text",
    primaryValue: "{{subText}} Request",
    stringKey: "APPROVAL_SUB_TEXT",
  },
};

export default translations;
